<div
  class="layout-flex-1-1 layout-vertical responsive"
  [style.height.%]="100"
  [class.draggable]="editable()"
>
  <div class="header" [ngClass]="DRAG_HANDLE_CLASS">
    <div class="header-row">
      @if (editable() && displayResizeHandlers()) {
        <rt-icon class="drag-icon" name="drag-vertical" />
      }
      <div class="header-info" [class.overflow-hidden]="filtersOverflowHidden()">
        <ng-content select="[slot=header]" />
      </div>
      <div class="header-actions">
        <!-- stop propagation for kiwihr app. Can be removed when grid is managed by tellent client -->
        <div
          class="header-actions-container layout-horizontal justify-flex-end layout-flex-1"
          (mousedown)="$event.stopPropagation()"
        >
          <ng-content select="[slot=header-actions]" />
        </div>
      </div>
    </div>
  </div>

  <ng-content />

  <div class="gridster-item-content visualization-container layout-flex-1-1">
    <ng-content select="[slot=renderer]" />
  </div>
  @if (editable() && displayResizeHandlers()) {
    <div class="resizer-wrap">
      <rt-icon name="resize-bottom-right" />
    </div>
  }
</div>
